import { media } from '@/media';
import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 10% repeat(26, 34px);
  column-gap: 4px;
  row-gap: 2px;
  justify-content: center;
  align-items: center;
  position: relative;

  ${media.mobile`
    justify-content: start;
    grid-template-columns: 20% repeat(26, 34px);
  `}
`;

export const SquareWrapper = styled.div``;
